import React, { JSX } from 'react';
import { PostsPerPageType } from '../store';
import Style from './ArchivePosts.module.scss';
import PostSkeleton from './PostSkeleton';

type Props = {
  postsPerPage: PostsPerPageType;
};

const ArchivePostsSkeleton: React.FC<Props> = ({ postsPerPage }): JSX.Element => {
  return (
    <div>
      {
        <div className={Style.thead}>
          <div className={Style.date}>日付</div>
          <div className={Style.category}>カテゴリー</div>
          <div className={Style.title}>件名</div>
        </div>
      }
      {[...Array(postsPerPage).keys()]
        .map((n) => n)
        .map((i) => {
          return <PostSkeleton key={i} />;
        })}
    </div>
  );
};

export default ArchivePostsSkeleton;
